var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBodhiYellowOIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mockup6",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fleet-ribbon",
    transform: "translate(-30.000000, -34.000000)",
    fill: "#FFD110",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(30.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.9951574,5.44839538 C32.1549637,3.66690151 30.0242131,2.26045899 27.6997579,1.41659348 C25.1815981,0.478965131 22.566586,-0.0836118781 19.9515738,0.0101509567 C17.3365617,0.0101509567 14.6246973,0.478965131 12.2033898,1.51035631 C9.78208232,2.44798466 7.65133172,3.94819002 5.81113801,5.72968388 C3.97094431,7.51117774 2.51815981,9.66772294 1.5496368,12.1055566 C0.484261501,14.6371532 0,17.3562754 0,20.0753976 L10.0726392,20.0753976 C10.0726392,18.6689551 10.2663438,17.1687497 10.8474576,15.85607 C11.3317191,14.6371532 12.0096852,13.5119992 12.9782082,12.5743708 C13.8498789,11.6367425 14.9152542,10.9804026 16.0774818,10.5115885 C18.5956416,9.57396011 21.3075061,9.57396011 23.8256659,10.5115885 C24.9878935,10.9804026 26.1501211,11.7305053 27.0217918,12.5743708 C27.9903148,13.5119992 28.6682809,14.6371532 29.1525424,15.85607 C29.7336562,17.1687497 29.9273608,18.6689551 29.9273608,20.0753976 L40,20.0753976 C40,17.2625126 39.5157385,14.4496275 38.4503632,11.8242681 C37.3849879,9.48019727 35.8353511,7.32365207 33.9951574,5.44839538 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1065375,38.4529132 C17.0460048,40.5156956 22.6634383,40.5156956 27.6997579,38.4529132 C28.8619855,37.9840991 30.0242131,37.3277592 31.0895884,36.6714194 L8.81355932,36.6714194 C9.78208232,37.3277592 10.9443099,37.9840991 12.1065375,38.4529132 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8547215,30.2955466 C19.0799031,30.2955466 18.2082324,30.2017838 17.433414,30.0142581 L2.51815981,30.0142581 C3.19612591,31.2331749 3.97094431,32.358329 4.93946731,33.3897201 L34.8668281,33.3897201 C35.7384988,32.358329 36.6101695,31.2331749 37.2881356,30.0142581 L22.4697337,30.0142581 C21.598063,30.2017838 20.7263923,30.2955466 19.8547215,30.2955466 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7506053,24.1071995 C10.653753,23.825911 10.5569007,23.6383853 10.4600484,23.3570968 L0.0968523002,23.3570968 C0.290556901,24.4822508 0.581113801,25.6074049 0.968523002,26.7325589 L12.3002421,26.7325589 C11.7191283,25.8886934 11.1380145,25.0448278 10.7506053,24.1071995 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0556901,24.2009623 C28.6682809,25.0448278 28.1840194,25.8886934 27.6029056,26.638796 L38.7409201,26.638796 C39.1283293,25.513642 39.4188862,24.388488 39.6125908,23.263334 L29.346247,23.263334 C29.2493947,23.6383853 29.1525424,23.9196738 29.0556901,24.2009623 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBodhiYellowOIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bodhiYellowO_icon.7a7d5e663c8c7a3852d8eb0388e4785b.svg";